/**
 * THE CODE THE BACKEND SENT BACK WITH ITSELF, split into digits — or null.
 *
 * ⚠️ THIS IS A TEST AFFORDANCE, AND THE SERVER IS THE ONE DECIDING. `POST
 * /auth/login/request-otp` normally answers with a message and nothing else; for test
 * accounts it also returns `data.otp`, so that whoever is testing does not need a mailbox
 * or a SIM to get through the login screen. Asked for by the client.
 *
 * ⚠️ THE CLIENT CANNOT TELL A TEST ACCOUNT FROM A REAL ONE, and does not try. It fills in
 * whatever the response contains, so the entire safety of this rests on the backend not
 * putting `otp` in the payload for a real user. That is the right place for the decision —
 * only the server knows which accounts are test ones — but it is worth being explicit that
 * there is no second line of defence here. If real codes ever start coming back, they will
 * be typed into the box automatically.
 *
 * ⚠️ VALIDATED, NOT TRUSTED VERBATIM. Anything that is not a plain run of digits of the
 * expected length is ignored rather than scattered across the inputs — a `null`, a masked
 * `"******"`, or a longer string would otherwise half-fill the boxes and leave a form that
 * looks completed and is not.
 */
export function otpFromResponse(data, length = 6) {
    const raw = data?.otp
    if (raw == null) return null

    const code = String(raw).trim()
    if (code.length !== length || !/^\d+$/.test(code)) return null

    return code.split('')
}

export default otpFromResponse
